

<!-- DeliveryPointSelection.svelte -->


<script>
  import { onMount, createEventDispatcher, afterUpdate } from 'svelte';

  export let areaId;

  let deliveryPoints = [];
  let selectedDeliveryPoint = null;
  let isLoading = false;

  const dispatch = createEventDispatcher();

  onMount(async () => {
    isLoading = true;

    try {
      const accessToken = localStorage.getItem('accessToken');
      const response = await fetch('https://groupfruits.online/shop/api/DeliveryPointsForAreaView/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWT ${accessToken}`,
        },
        body: JSON.stringify({ area_id: areaId }),
      });

      if (response.ok) {
        const data = await response.json();
        deliveryPoints = data.delivery_points;
      } else {
        console.error('Error fetching delivery points:', response.statusText);
      }
    } catch (error) {
      console.error('Network error:', error);
    } finally {
      isLoading = false;
    }
  });

  function handleDeliveryPointClick(point) {
    selectedDeliveryPoint = point.id;

    // Reset the selected state for all delivery points
    deliveryPoints = deliveryPoints.map(dp => ({ ...dp, selected: false }));

    // Set the selected delivery point
    const selectedDeliveryPointObj = deliveryPoints.find(dp => dp.id === selectedDeliveryPoint);
    selectedDeliveryPointObj.selected = true;
  }

  function handleBackClick() {
    dispatch('backToAreaSelection');
  }

  afterUpdate(() => {
    if (selectedDeliveryPoint) {
      dispatch('deliveryPointSelected', { deliveryPointId: selectedDeliveryPoint });
      selectedDeliveryPoint = null;
    }
  });
</script>


<style>
  :global(body) {
    -webkit-tap-highlight-color: transparent;
  }



* {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}


  .container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
  }

  .delivery-point {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 16px;
    cursor: pointer;
    transition: box-shadow 0.3s ease, transform 0.3s ease, background-color 0.3s ease;
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    user-select: none;
    position: relative;
  }

  .delivery-point:active {
    transform: scale(0.98);
  }

  .delivery-point:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .delivery-point.selected {
    background-color: #e0f7e0;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .delivery-point.selected::after {
    content: '✓';
    position: absolute;
    top: 8px;
    right: 12px;
    font-size: 20px;
    color: #4caf50;
  }

  .delivery-point h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 8px;
    color: #333333;
  }

  .delivery-point p {
    margin: 0;
    font-size: 14px;
    color: #666666;
    white-space: pre-wrap;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-top: 20px;
    padding-right: 10px;
    padding-left: 10px;
    padding-bottom: 20px;
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .header h2 {
    font-size: 20px;
    margin: 0;
    padding: 0 20px;
    color: #dd2e44;
    flex-grow: 1;
    text-align: center;
  }

  .back-arrow {
    font-size: 24px;
    cursor: pointer;
    color: #666;
    transition: color 0.3s ease;
  }

  .back-arrow:hover {
    color: #333;
  }

  .loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }

  .dot-loader {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #8bc6ec;
    margin: 0 4px;
    animation: dot-pulse 1.2s infinite ease-in-out both;
  }

  .dot:nth-child(1) {
    animation-delay: -0.32s;
  }

  .dot:nth-child(2) {
    animation-delay: -0.16s;
  }

  @keyframes dot-pulse {
    0%,
    80%,
    100% {
      transform: scale(0.6);
    }
    40% {
      transform: scale(1);
    }
  }
</style>

<svelte:head>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
  </style>
</svelte:head>

<svelte:body style="margin: 0; padding: 0; font-family: 'Roboto', sans-serif; background-color: white;" />

{#if isLoading}
  <div class="loader">
    <div class="dot-loader">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>
{:else if deliveryPoints.length > 0}
  <div class="header">
    <span class="back-arrow" on:click={handleBackClick}>&#8592;</span>
    <h2>Select Point</h2>
  </div>
  <div class="container">
    {#each deliveryPoints as point}
      <div
        class="delivery-point"
        class:selected={selectedDeliveryPoint === point.id}
        on:click={() => handleDeliveryPointClick(point)}
      >
        <h3>{point.name}</h3>
        <p>{point.address.replace(/\\r\\n/g, '\n')}</p>
      </div>
    {/each}
  </div>
{:else}
  <p>Error: Could not load delivery points</p>
{/if}

